// import "./list.scss"
import Sidebar from "../../../components/sidebar/Sidebar";
import Navbar from "../../../components/navbar/Navbar";
import Datatable from "../../../components/datatable/Datatable";
import ExpencesService from "../../../services/expences";
import { useEffect, useState } from "react";
import CurriculumModal from "./components/CurriculumModal";
import Toast from "../../../components/toast/Toast";
import columnsHeader from "./ColumnsHeaderData";
import Loader from "../../../components/spinner/Spinner";
import Backdrop from "../../../components/backdrop/Backdrop";

const CurriculumExpences = () => {
  const [rowData, setRowData] = useState([]);
  const [open, setOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState({});
  const [toastOpen, setToastOpen] = useState(false);
  const [toastMsg, setToastMsg] = useState("");
  const [toastStatus, setToastStatus] = useState("");
  const [loading, setLoading] = useState(true);
  const [backdrop, setBackdrop] = useState(false);
  const [isSidebar, setIsSidebar] = useState(null);

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure to delete the record?")) return;
    setBackdrop(true);
    try {
      await ExpencesService.deleteCurriculumExpences(id);
      setToastOpen(true);
      setToastMsg("Curriculum deleted successfully");
      setToastStatus("success");
      setOpen(false);
      setBackdrop(false);
      getAllCurriculumExpences();
    } catch (err) {
      setBackdrop(false);
      console.log(err);
    }
  };

  useEffect(() => {
    getAllCurriculumExpences();
  }, []);

  const getAllCurriculumExpences = async () => {
    setLoading(true);
    try {
      let { data } = await ExpencesService.fetchCurriculumExpences();
      setRowData(data.data);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.log(err);
    }
  };

  const onSubmit = async (values) => {
    setBackdrop(true);
    try {
      if (values.id) {
        await ExpencesService.updateCurriculumExpences(values);
      } else {
        await ExpencesService.addCurriculumExpences(values);
      }
      setToastOpen(true);
      setToastMsg(
        `Curriculum ${values?.id ? "updated" : "created"} successfully`,
      );
      setToastStatus("success");
      setOpen(false);
      getAllCurriculumExpences();
      setSelectedRow({});
      setBackdrop(false);
    } catch (err) {
      setBackdrop(false);
      console.log(err);
      setToastOpen(true);
      setToastStatus("error");
      setToastMsg("Something went wrong!");
    }
  };

  return (
    <div className="list">
      <Sidebar isSidebar={isSidebar} />
      <div className="listContainer">
        <Navbar isSidebar={isSidebar} setIsSidebar={setIsSidebar} />
        {loading ? (
          <Loader />
        ) : (
          <Datatable
            pageTitle={"Co-Curriculum Expences"}
            columnsData={columnsHeader.columnsData}
            actionColumn={columnsHeader.actionHeader(
              handleDelete,
              setOpen,
              setSelectedRow,
            )}
            rowData={rowData}
            addBtnTxt={"Add Co-Curriculum Expences"}
            onAddBtn={() => {
              setOpen(true);
              setSelectedRow({});
            }}
          />
        )}

        {open && (
          <CurriculumModal
            onSubmit={onSubmit}
            selectedRow={selectedRow}
            open={open}
            onClose={() => setOpen(false)}
          />
        )}
      </div>
      {toastOpen && (
        <Toast
          toastOpen={toastOpen}
          toastClose={() => setToastOpen(false)}
          toastMsg={toastMsg}
          toastStatus={toastStatus}
        />
      )}
      {backdrop && <Backdrop />}
    </div>
  );
};

export default CurriculumExpences;
